import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BackButton } from "../../../components/features/BackButton";
import { paths } from "../../../config/paths";
import { looks } from "../../../features/looks-gallery/data/looks";
import { Look } from "../../../features/looks-gallery/data/types";
import { LookDetails } from "../../../features/looks-gallery/components/LookDetails";
import { LooksCarrousel } from "../../../features/looks-gallery/components/LooksCarrousel";
import { getAssetPath } from "../../../lib/assetPath";

export const LooksGallery = () => {
  const navigate = useNavigate();
  const [selectedLook, setSelectedLook] = useState<Look>(looks[0]);
  const [isLookDetails, setIsLookDetails] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  return (
    <div
      className="relative flex flex-col w-full h-full justify-end items-center overflow-hidden"
      style={{
        backgroundImage: `url(${getAssetPath(selectedLook.imagePath)})`,
        backgroundSize: "cover",
        backgroundPosition: "top",
        backgroundRepeat: "no-repeat",
      }}
    >
      <>
        {isVideoPlaying ? (
          <div className="relative w-full h-full">
            <video
              autoPlay
              muted
              loop
              playsInline
              disablePictureInPicture
              className="absolute inset-0 w-full h-full object-cover"
              style={{ pointerEvents: "none" }}
            >
              <source
                src={getAssetPath(selectedLook.videoPath.replace(/\.mp4$/i, ".webm"))}
                type="video/webm"
              />
              <source src={getAssetPath(selectedLook.videoPath)} type="video/mp4" />
            </video>
            <div className="absolute z-10 bottom-4 left-4 text-white">
              <BackButton onClick={() => setIsVideoPlaying(false)} />
            </div>
          </div>
        ) : isLookDetails ? (
          <div className="flex flex-col gap-4 items-start text-white p-4 max-w-screen  w-full">
            {" "}
            <LookDetails
              selectedLook={selectedLook}
              isVideoPlaying={isVideoPlaying}
              setIsVideoPlaying={setIsVideoPlaying}
            />
            <BackButton onClick={() => setIsLookDetails(false)} />
          </div>
        ) : (
          <div className="flex flex-col gap-4 items-start text-white p-4 max-w-screen  w-full">
            <LooksCarrousel
              selectedLook={selectedLook}
              onLookSelect={setSelectedLook}
              onLookDetails={() => setIsLookDetails(true)}
            />
            <BackButton onClick={() => navigate(paths.looksGallery.path)} />
          </div>
        )}
      </>
    </div>
  );
};
